import { AllowedBlockchains } from "../../../store/chain/models/internal";

export interface PurchaseForm {
  amount: number;
  chain: AllowedBlockchains;
}

export const AMOUNT_OPTIONS = [20, 50, 100, 200, 500, 1000] as const;
